// src/components/Notifications/NotificationContainer.tsx
import React from 'react';
import { useNotification } from '../../context/NotificationContext';
import ToastNotification from './ToastNotification';

const NotificationContainer: React.FC = () => {
  const { notifications, removeNotification } = useNotification();

  return (
    <>
      {notifications.map((notification, index) => (
        <ToastNotification 
          key={notification.id}
          notification={notification}
          onClose={removeNotification}
          index={index}
        />
      ))}
    </>
  );
};

export default NotificationContainer;